import React from "react";
import Modal from "react-modal";
import '../modal/modal.css';

Modal.setAppElement("#root");

const CommonModal = ({
  isOpen,
  onRequestClose,
  title,
  children,
  style = {},
  showCloseButton = true,
  shouldCloseOnOverlayClick = false,
  className = "",
  overlayClassName = "",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      className={`modal-content ${className}`}
      overlayClassName={`modal-overlay ${overlayClassName}`}
      style={style}
    >
      {showCloseButton && (
        <button className="modal-close-btn" onClick={onRequestClose}>
          &times;
        </button>
      )}
      {title && <h2 className="modal-title">{title}</h2>}
      <div className="modal-body">{children}</div>
    </Modal>
  );
};

export default CommonModal;
